import script from "./DocumentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentItem.vue?vue&type=script&setup=true&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=2c12bf70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c12bf70"]])

export default __exports__